import React from "react"
import PropTypes from "prop-types"
import styles from "./Breadcrumb.module.scss"
import LinkButton from "../linkButton"

const Breadcrumb = ({ currentPageTitle, parentPage }) => {
  if (!parentPage || !currentPageTitle) {
    return null
  }
  return (
    <div className={styles.breadcrumb}>
      <LinkButton to={`/${parentPage.slug.current}`} className={styles.parentPage}>
        {parentPage.title}
      </LinkButton>
      <span className={styles.divider}>/</span>
      <p className={styles.currentPage}>{currentPageTitle}</p>
    </div>
  )
}

Breadcrumb.propTypes = {
  currentPageTitle: PropTypes.string,
  parentPage: PropTypes.shape({
    title: PropTypes.string,
    slug: PropTypes.shape({ current: PropTypes.string }),
  }),
}

export default Breadcrumb
